import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  CountryPicker,
  ICountryPickerProps,
} from '@work4all/components/lib/components/entity-picker/country-picker/CountryPicker';

import { reactRefSetter } from '@work4all/utils';

import { LabeledInput } from '../../containers/mask-overlays/locked-inputs';

interface CountryPickerFieldProps
  extends Omit<ICountryPickerProps<false>, 'multiple'> {
  error?: string;
}

export const CountryPickerField = React.forwardRef<
  HTMLDivElement,
  CountryPickerFieldProps
>(function CountryPickerField(props, ref) {
  const { error, ...pickerProps } = props;
  const { value, onChange } = pickerProps;

  const { t } = useTranslation();

  const wrapperRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={reactRefSetter(wrapperRef, ref)}>
      <EntityPickerPopover
        anchorEl={wrapperRef}
        picker={<CountryPicker {...pickerProps} multiple={false} />}
      >
        <LabeledInput
          value={value?.shortName ?? ''}
          label={t('INPUTS.COUNTRY')}
          error={error}
          onClear={() => {
            onChange(null);
          }}
        />
      </EntityPickerPopover>
    </div>
  );
});
